// stores/user.ts
import axios from 'axios';
import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useUserStore = defineStore('user', () => {
  const isLoggedIn = ref(false);
  const isShoppingManageLoggedIn = ref(false);
  const isGroupManageLoggedIn = ref(false);
    const isUpgradeLoggedIn = ref(false);
  const userInfo = ref<any>(null);
  const permissions = ref<any>(null);

  const login = (loginType: string) => {
    const tokenKey = `${loginType}Token`;
    const userInfoKey = `${loginType}UserInfo`;
    const permissionsKey = `${loginType}Permissions`;
    if (loginType === 'guarantee') {
      isLoggedIn.value = true;
    } else if (loginType === 'shoppingManage') {
      isShoppingManageLoggedIn.value  = true;
    }else if (loginType === 'groupManage') {
      isGroupManageLoggedIn.value  = true;
    }else if (loginType === 'upgrade') {
      isUpgradeLoggedIn.value  = true;
    }
    // 从本地存储中读取信息
    const token = localStorage.getItem(tokenKey);
    const storedUserInfo = localStorage.getItem(userInfoKey);
    const storedPermissions = localStorage.getItem(permissionsKey);

    if (token) {
      axios.defaults.headers['token'] = token; // 更新全局请求头中的 token
    }

    if (storedUserInfo) {
      userInfo.value = JSON.parse(storedUserInfo);
    }

    if (storedPermissions && storedPermissions !== 'undefined') {
      permissions.value = JSON.parse(storedPermissions);
    }
  };

  const logout = (loginType: string) => {
    userInfo.value = null;
    permissions.value = null;
    if (loginType === 'guarantee') {
      isLoggedIn.value = false;
    } else if (loginType === 'shoppingManage') {
      isShoppingManageLoggedIn.value  = false;
    }else if (loginType === 'groupManage') {
      isGroupManageLoggedIn.value  = false;
    }else if (loginType === 'upgrade') {
      isUpgradeLoggedIn.value  = false;
    }
    const tokenKey = `${loginType}Token`;
    const userInfoKey = `${loginType}UserInfo`;
    const permissionsKey = `${loginType}Permissions`;

    localStorage.removeItem(tokenKey);
    localStorage.removeItem(userInfoKey);
    localStorage.removeItem(permissionsKey);
  };

  return {
    isLoggedIn,
    isShoppingManageLoggedIn,
    isGroupManageLoggedIn,
    isUpgradeLoggedIn,
    userInfo,
    permissions,
    login,
    logout,
  };
});